<template>
  <transition name="slide-right">
    <cube-popup
      v-show="isVisible"
      ref="myPopup"
      type="my-popup"
      :center="false"
      position="right"
      class="filter-wrap"
      @mask-click="maskClick"
    >
      <cube-form
        :model="model"
        class="form"
        @reset="resetHandler"
      >
        <cube-form-group>
          <cube-form-item
            v-for="field in fields"
            :key="field.modelKey"
            :field="field"
          />
        </cube-form-group>
        <cube-form-group class="footer form-btn-box">
          <cube-button
            class="reset-btn cube-btn-light"
            type="reset"
          >
            {{ $t('message["1625"]') }}
          </cube-button>
          <cube-button
            class="confirm-btn cube-btn-primary"
            @click="submitHandler"
          >
            {{ $t('message["915"]') }}
          </cube-button>
        </cube-form-group>
      </cube-form>
    </cube-popup>
  </transition>
</template>

<script>

export default {
  components: {
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    keywords: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      isVisible: false,
      model: {
        keyword1: this.keywords.keyword1 || '',
        keyword2: this.keywords.keyword2 || '',
        keyword3: this.keywords.keyword3 || ''
      },
      fields: [
        {
          type: 'input',
          modelKey: 'keyword1',
          label: this.$t('message["387"]'),
          props: {
            placeholder: this.$t('message["773"]')
          }
        },
        {
          type: 'input',
          modelKey: 'keyword2',
          label: this.$t('message["605"]'),
          props: {
            placeholder: this.$t('message["782"]')
          }
        },
        {
          type: 'input',
          modelKey: 'keyword3',
          label: this.$t('message["1116"]'),
          props: {
            placeholder: this.$t('message["801"]')
          }
        }
      ]
    }
  },
  watch: {
    visible (val) {
      this.isVisible = val
      if (val) {
        this.model = this.keywords
      }
    }
  },
  methods: {
    hide () {
      this.$emit('update:visible', false)
    },
    maskClick () {
      this.resetHandler()
    },
    resetData () {
      this.model.keyword1 = ''
      this.model.keyword2 = ''
      this.model.keyword3 = ''
    },
    resetHandler (e) {
      this.hide()
      this.resetData()
      this.$router.push({
        name: 'InqueryAudit',
        query: {
          ...this.$route.query,
          keywords: ''
        }
      })
    },
    submitHandler (e) {
      this.hide()
      this.$router.push({
        name: 'InqueryAudit',
        query: {
          ...this.$route.query,
          keywords: encodeURIComponent(JSON.stringify(this.model)),
          limit: 10,
          page: 1
        }
      })
      this.resetData()
    }
  }
}
</script>

<style lang="scss" scoped>
.slide-right-enter,
.slide-right-leave-active {
  -webkit-transform: translate3d(100%, 0, 0);
  transform: translate3d(100%, 0, 0);
}

.slide-right-enter-active,
.slide-right-leave-active {
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

.form {
  .code {
    padding: 10px 20px;
    border-bottom: 1px solid #ccc;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    .cube-input,
    .cube-input_active {
      background-color: #f5f5f5;
    }
    .cube-input,
    .cube-input_active:after {
      border: 0;
      border-color: transparent;
    }
  }
}
.footer {
  z-index: 99;
  display: flex;
  justify-content: space-between;
  height: auto;
  padding: 8px;
  background-color: #fff;
  ::v-deep .cube-form-group-content {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .cube-btn {
    width: 176px;
    height: 46px;
    line-height: 46px;
    padding: 0 !important;
  }
}
</style>
